import { fetchFilterOptions } from './api/fetchLeadFilter';
import { getAdmins } from './api/Admin/getAdminsApi';
import { getAllDesksApi } from './api/Admin/desk/getAllDesksApi';
import { getAffiliate } from './api/Affiliate/getAffiliateApi';
import { getDistinctLeadCampaignsApi } from './api/Admin/getDistinctLeadCampaignsApi';
import { sortOrders } from './forms/sortOrder';

export const loadLeadFilterOptions = async (fields = [], { langSelected = 'ru', sortLabels } = {}) => {
    const options = {};

    await Promise.all(
        fields.map(async (field) => {
            if (field.key === 'manager_id') {
                try {
                    const admins = await getAdmins();
                    options[field.key] = (admins.data || []).map((admin) => ({
                        value: admin.id,
                        label: admin.first_name ? `${admin.first_name} ${admin.last_name || ''}`.trim() : admin.email,
                    }));
                } catch (error) {
                    options[field.key] = [];
                }
                return;
            }

            if (field.key === 'desk_id') {
                try {
                    const desksData = await getAllDesksApi();
                    options[field.key] = (desksData.data || []).map((desk) => ({
                        value: desk.id,
                        label: `${desk.name || ''} (${desk.description || ''})`.trim(),
                        name: desk.name,
                    }));
                } catch (error) {
                    options[field.key] = [];
                }
                return;
            }

            if (field.key === 'affiliator_id') {
                try {
                    let allAffiliators = [];
                    let currentPage = 1;
                    let totalPages = 1;
                    const maxPerPage = 50;

                    do {
                        const result = await getAffiliate(currentPage, maxPerPage);
                        allAffiliators = allAffiliators.concat(result.data || []);
                        totalPages = result.meta.total_pages;
                        currentPage++;
                    } while (currentPage <= totalPages);

                    options[field.key] = allAffiliators.map((affiliator) => ({
                        value: affiliator.id,
                        label: affiliator.first_name ? `${affiliator.first_name} ${affiliator.last_name || ''}`.trim() : affiliator.email,
                    }));
                } catch (error) {
                    options[field.key] = [];
                }
                return;
            }

            if (field.key === 'campaign') {
                try {
                    const campaignsResult = await getDistinctLeadCampaignsApi();
                    options[field.key] = (campaignsResult.data || []).map((item) => ({
                        value: item.id,
                        label: item.name,
                    }));
                } catch (error) {
                    options[field.key] = [];
                }
                return;
            }

            if (field.endpoint) {
                try {
                    const data = await fetchFilterOptions(field.endpoint, langSelected);
                    options[field.key] = data || [];
                } catch (error) {
                    options[field.key] = [];
                }
            }
        })
    );

    if (sortLabels) {
        options.sortOrder = sortOrders.map((order) => ({
            value: order.value.toUpperCase(),
            label: sortLabels[order.labelKey],
        }));
    }

    return options;
};
